module.exports = __webpack_public_path__ + "img/HC1006-01.66ef5385.jpg";